import React from "react";
import { Box } from "@mui/material";
import { InputLabel } from "../../../components";
import { StyledWorkOrderStack } from "../styles";

const required = true;

export const items = [
  {
    id: "workOrder",
    label: "Work Order",
    required,
  },
  {
    id: "partNumber",
    label: "Part Number",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "quantity",
    label: "Quantity",
    required,
  },
  {
    id: "x",
    label: "",
  },
];

export const WorkOrderTableHeader = ({ hidden }) => {
  return (
    <StyledWorkOrderStack
      sx={{
        backgroundColor: "hubColors.greyLighter",
        borderTop: "1px solid",
        borderColor: "hubColors.greyLight",
      }}
    >
      {items?.map((cell, idx) => (
        <Box
          key={idx}
          sx={{
            borderRight: "1px solid",
            borderColor: "hubColors.greyLight",
            padding: "4px 5px",
            height: "100%",
          }}
        >
          <InputLabel
            key={cell.id}
            label={cell.label}
            required={cell.required}
            marginLeft="5px"
            marginBottom="0px"
            sx={{
              textWrap: "nowrap",
            }}
          />
        </Box>
      ))}
    </StyledWorkOrderStack>
  );
};

export default WorkOrderTableHeader;
